

export default function SpinnerLoader (){

    return(
        <>
            <div className="spinner-border text-danger" role="status">
                <span className="visually-hidden"></span>
            </div>
        </>
    )
}